<template>
  <li v-if="list">

    <input
        type="checkbox"
        :name="name"
        :id="title"
        :value="formValue"
        :required="required"
        :disabled="disabled"
        :checked="value"
        @change="onChange"
    />
    <label :for="title">{{ title }}</label>
  </li>
  <p v-else-if="field" class="field">
    <input
        type="checkbox"
        :name="name"
        :id="name"
        :value="formValue"
        :required="required"
        :disabled="disabled"
        :checked="value"
        @change="onChange"
    />
    <label :for="name" :class="{'series_label': series}">{{ title }}</label>
  </p>
    <p v-else-if="episode" class="field">
    <input
        type="checkbox"
        :name="name"
        :id="name"
        :value="formValue"
        :required="required"
        :disabled="disabled"
        :checked="value"
        @change="onChange"
    />
    <label :for="name">
      <strong>{{ title }}</strong><br />
      <slot />
    </label>
  </p>
  <div v-else>
    <input
        type="checkbox"
        ref="inputCheckbox"
        :name="name"
        :id="name"
        :value="formValue"
        :required="required"
        :disabled="disabled"
        :checked="value"
        @change="onChange"
    />
    <label :for="name" :class="{'color_dot': tvProgramFiltration, 'green': green, 'orange': orange, 'red': red}">{{ title }}</label>
  </div>
</template>

<script>
export default {
  name: 'app-checkbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    tvProgramFiltration: {
      type: Boolean,
      default: false
    },
    green: {
      type: Boolean,
      default: false
    },
    orange: {
      type: Boolean,
      default: false
    },
    red: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    checkboxId: {
      type: String,
      default: ''
    },
    formValue: {
      type: [String, Number],
      default: ''
    },
    theme: {
      type: String,
      default: 'light',
      validator: value => ['light', 'dark'].includes(value)
    },
    checked: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    list: {
      type: Boolean,
      default: false
    },
    field: {
      type: Boolean,
      default: false
    },
    series: {
      type: Boolean,
      default: false
    },
    episode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: this.checked
    }
  },
  computed: {
    checkboxClass() {
      return {
        [`checkbox-${this.theme}`]: true,
        'checkbox-checked': this.value,
        'checkbox-disabled': this.disabled,
        'checkbox-error': this.error
      }
    }
  },
  methods: {
    onChange(event) {
      const { checked } = event.target
      this.value = checked
      this.$emit('change', checked)
    },
    focus() {
      this.$refs.inputCheckbox.focus()
    }
  },
  watch: {
    checked(value) {
      this.value = value
    }
  }
}
</script>
